import { IndexColumn } from 'components/Table/Columns';
import useCustomLocation from 'hooks/useCustomLocation';
import useCustomRouter from 'hooks/useCustomRouter';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React from 'react';
import PRODUCTOS from 'utils/constants/PRODUCTOS';

const TablaPolizas = ({ data = [], diccionario = [] }) => {
  const router = useCustomRouter();
  const location = useCustomLocation();
  const bodyVerDetalles = (row) => {
    let urlRecuperar = `/recuperar-poliza?idPoliza=${row.idPoliza}&prodCodigo=${row.polDescripcionRamo}`;
    if (
      [
        PRODUCTOS.HOGAR,
        PRODUCTOS.PYMES,
        PRODUCTOS.LINEAS_FINANCIERAS,
        PRODUCTOS.RCP,
        PRODUCTOS.CYBER
      ].includes(row?.polDescripcionRamo) || row?.polProdCodigoCore === PRODUCTOS.DO
    ) {
      urlRecuperar = `/recuperar-poliza?idPoliza=${row.idPoliza}&prodCodigo=${row.polProdCodigoCore}`;
    }

    if (PRODUCTOS.CASUALITY === row?.polProdCodigoCore) {
      urlRecuperar = `/recuperar-cotizacion-casualitycontratistas?idPoliza=${row.idPoliza}&id=${row.cotCodigo}`;
    }
    if (PRODUCTOS.SEGUKIDS === row?.polProdCodigoCore) {
      urlRecuperar = `/kids/recuperar-poliza?idPoliza=${row.idPoliza}&codProducto=${row?.polProdCodigoCore}`;
    }
    
    if (PRODUCTOS.CASUALITY_GENERAL === row?.polProdCodigoCore) {
      urlRecuperar = `/recuperar-cotizacion-casualitygenerales?idPoliza=${row.idPoliza}&id=${row.cotCodigo}`;
    }

    if (!row.polizaPendiente) {
      return (
        <button
          className="btn btn-primary btn-block btn-sm"
          onClick={router.goTo(`/detalle-poliza/${row.idPoliza}`)}
        >
          Ver detalles
        </button>
      );
    }
    if (row?.recuperar) {
      return (
        <button
          className="btn btn-primary btn-block btn-sm"
          onClick={router.goTo(urlRecuperar)}
        >
          Recuperar póliza
        </button>
      );
    }

  };

  return (
    <DataTable
      value={data}
      className="p-datatable-gridlines p-datatable-sm"
      rowHover
      paginator
      rows={10}
      rowsPerPageOptions={[10, 25, 50]}
      emptyMessage="No se han encontrado resultados"
      resizableColumns
      autoLayout
    >
      {IndexColumn()}

      {diccionario.map((column, index) => (
        <Column {...column} key={index} />
      ))}

      {['/listado-polizas-certificados', '/listado-pre-polizas'].includes(
        location.pathname,
      ) && (
          <Column
            header="Detalles"
            body={bodyVerDetalles}
            style={{ width: '225px' }}
          />
        )}
    </DataTable>
  );
};

export default TablaPolizas;
